import React, { Component, Fragment } from 'react';
import './index.scss';
import { connect } from 'react-redux';
import { authenticate, logout } from '../../store/actions/login';
import services from '../../services/services';
import Loader from 'react-loader-spinner';
import { ToastContainer } from 'react-toastify';
import { Input } from 'react-materialize';
import Dialog from '../../components/Dialog';
import Button from '@material-ui/core/Button';
import { allNotifications } from '../../utils/toastify';
import AcceptTermsModal from '../AcceptTerms';
import AccessDeniedModal from '../AccessDenied';
import AccessDeniedTermNotAcceptedModal from '../AccessDeniedTerm';

const { notifyErrorBottomRight } = allNotifications;

class LoginScreen extends Component {
  state = {
    viewPassaword: false,
    password: '',
    cpf: '',
    isAuth: false,
    isLoading: false,
    valueInputBenefCode: '',
    emailUser: '',
    valueInputResetToken: '',
    valueInputDdd: '',
    valueInputCelular: '',
    valueInputNewPassword: '',
    valueInputConfirmPassword: '',
    version: null,


    modalBoxes: {
      accessDenied: false,
      acceptTerm: false,
      accessDeniedTerm: false
    }
  };

  modalChangePassword = React.createRef();

  modalConfirmEmail = React.createRef();

  modalResultChangedPassword = React.createRef();

  modalResultChangeSuccess = React.createRef();

  componentDidMount = () => {
    console.log(process.env.REACT_APP_environment);
    console.log(process.env.NODE_ENV);
    const version = localStorage.getItem('appVersion');
    this.setState({ version });
  };

  togglePassword = () => {
    this.setState({ viewPassaword: !this.state.viewPassaword });
  };

  handlePasswordChange = event => this.setState({ password: event.target.value });

  validCpf = strCPF => {
    let Soma;
    let Resto;
    Soma = 0;
    if (strCPF === '00000000000') return false;

    for (let i = 1; i <= 9; i++) Soma += parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (let i = 1; i <= 10; i++) Soma += parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(10, 11))) return false;
    return true;
  };

  ValidCnpj = (cnpj) => {
    const c = cnpj.replace(/[^A-Z\d]/gi, '').toUpperCase();

    if (c.length !== 14 || /^0{14}$/.test(c)) return false;

    const pesos = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]; 
    let soma1 = 0;
    let soma2 = 0;

    for (let i = 0; i < 12; i++) {
        const valor = c.charCodeAt(i) - 48;
        
        soma1 += valor * pesos[i + 1];
        soma2 += valor * pesos[i];
    }

    const dv1 = (soma1 % 11 < 2) ? 0 : 11 - (soma1 % 11);

    soma2 += dv1 * pesos[12];
    const dv2 = (soma2 % 11 < 2) ? 0 : 11 - (soma2 % 11); 

    return c.substring(12) === `${dv1}${dv2}`;
  };

  handleCpfChange = event => {
    const cpf = event.target.value.toString();
    this.setState({ cpf });
  };

  toLoggedArea() {
    const {
      history: { push }
    } = this.props;

    push('/');
  }

  handleSubmit = async event => {
    event && event.preventDefault();
    const { cpf, password } = this.state;
    const {
      authenticate = [],
      history: { push }
    } = this.props;

    this.setState({ isLoading: true });

    const isCpfCnpj = this.validCpf(cpf) || this.ValidCnpj(cpf);

    const resLogin = await authenticate({ cpf, password, isCpfCnpj }).catch(error => {
      this.notify(error.message);
      this.forceLogout();
      this.setState({ isLoading: false });
    });
    if(resLogin == undefined){
      notifyErrorBottomRight('Serviço indisponível no momento tente novamente mais tarde.');
      this.setState({ isLoading: false });
      return;
    }
    if (resLogin.status === 'ERROR')  {
      this.notify(resLogin.details);
      this.setState({ isLoading: false });
      return;
    }
    // if(!resLogin.dataCredenciamento){
    //   this.toggleModalBoxAccessDenied();
    //   this.setState({ isLoading: false });
    //   return;
    // }
    
    const resTerm = await services.login('checkTermAccept', cpf).catch(error => {
      this.notify('Serviço indisponível no momento tente novamente mais tarde.');
      this.forceLogout();
      this.setState({ isLoading: false });
    });
    if (resTerm.data && resTerm.data.sucesso){
      if(resTerm.data.tokenSucesso.aceiteContratual) {
        this.setState({ isAuth: true, isLoading: false });

        this.toggleModalBoxAcceptTerms();
      } else {
        this.forceLogout();
        localStorage.clear();
        this.setState({ isLoading: false });
        this.toggleModalBoxTermNotAccepted();
      }
    }else{
      notifyErrorBottomRight('Serviço indisponível no momento tente novamente mais tarde.');
      this.forceLogout();
      this.setState({ isLoading: false });
    }
  };

  handleChangeInputBenefCode = event => {
    this.setState({
      valueInputBenefCode: event.target.value
    });
  };

  handleChangeInputResetToken = event => {
    this.setState({
      valueInputResetToken: event.target.value
    });
  };

  handleChangeInputNewPassword = event => {
    this.setState({
      valueInputNewPassword: event.target.value
    });
  };

  handleChangeInputConfirmPassword = event => {
    this.setState({
      valueInputConfirmPassword: event.target.value
    });
  };

  handleChangeInputDdd = event => {
    this.setState({
      valueInputDdd:
        event.target.value.length > 2 ? event.target.value.slice(0, 2) : event.target.value
    });
  };

  handleChangeInputCelular = event => {
    this.setState({
      valueInputCelular:
        event.target.value.length > 9 ? event.target.value.slice(0, 9) : event.target.value
    });
  };

  validateRecoverToken = async () => {
    try {
      const recoverToken = this.state.valueInputResetToken;

      if (recoverToken === '') {
        this.notify('Todos os campos são obrigatórios');
        return;
      }

      const codBenef = this.state.valueInputBenefCode;
      const response = await services.recoverPsw('validateToken', { codBenef, recoverToken });

      if (response.data.success) {
        await services.recoverPsw('wsloginRecover', codBenef);
        this.modalResultChangedPassword.current.setState({ modalActive: true });
      } else {
        this.notify(response.data.message);
        return false;
      }
    } catch (err) {
      return this.notify(err);
    } finally {
      this.modalConfirmEmail.current.setState({ modalActive: false });
    }
  };

  sendRecoverTokenEmail = async event => {
    const codigo = this.state.valueInputBenefCode;
    let response;

    if (codigo === '') {
      this.notify('Todos os campos são obrigatórios');
      return;
    }

    try {
      response = await services.recoverPsw('sendRecoverTokenEmail', codigo);
      this.modalConfirmEmail.current.setState({ modalActive: true });
    } catch (error) {
      return this.notify(error);
    } finally {
      this.modalChangePassword.current.setState({ modalActive: false });
    }

    this.setState({ emailUser: response });

    return { codigo };
  };

  createNewLogin = async () => {
    if (this.state.valueInputConfirmPassword !== this.state.valueInputNewPassword) {
      this.notify('As senhas digitadas não conferem');
      return;
    }

    const params = {
      codigo: this.state.valueInputBenefCode,
      ddd: this.state.valueInputDdd,
      celular: this.state.valueInputCelular,
      newPassword: this.state.valueInputNewPassword
    };

    if (
      params.codigo === '' ||
      params.ddd === '' ||
      params.celular === '' ||
      params.newPassword === ''
    ) {
      this.notify('Todos os campos são obrigatórios');
      return;
    }

    try {
      await services.recoverPsw('newLogin', params);
      this.modalResultChangedPassword.current.setState({ modalActive: false });
      this.modalResultChangeSuccess.current.setState({ modalActive: true });
    } catch (error) {
      error.data ? this.notify(error.data.descricao) : this.notify('Erro ao alterar a senha');
    }
  };

  notify = message => {
    notifyErrorBottomRight(message);
  };

  toggleModalBoxAcceptTerms() {
    this.setState({
      modalBoxes: {
        ...this.state.modalBoxes,
        acceptTerm: !this.state.modalBoxes.acceptTerm
      }
    });
  }

  toggleModalBoxAccessDenied() {
    this.setState({
      modalBoxes: {
        ...this.state.modalBoxes,
        accessDenied: !this.state.modalBoxes.accessDenied
      }
    });
  }

  toggleModalBoxTermNotAccepted() {
    this.setState({
      modalBoxes: {
        ...this.state.modalBoxes,
        accessDeniedTerm: !this.state.modalBoxes.accessDeniedTerm
      }
    });
  }

  forceLogout = () => {
    const { logout = [] } = this.props;
    logout();
    this.setState({ isAuth: false });
  };

  render() {
    const { emailUser, isLoading, version } = this.state;
    return (
      <>
        <form onSubmit={this.handleSubmit}>
          <ToastContainer />
          <div className="LoginScreen">
            <div className="header">
              <span className="header--logo" />
            </div>
            <div className="content">
              <div className="content-box--login input-field col s12">
                <Input
                  className="content--login validate"
                  type="number"
                  id="login"
                  name="login"
                  maxLength="14"
                  value={this.state.cpf}
                  onChange={this.handleCpfChange}
                  label="Código do prestador"
                />
              </div>

              <div className="content-box--password input-field col s12">
                <Input
                  id="password"
                  className="content--password"
                  name="password"
                  value={this.state.password}
                  type={this.state.viewPassaword ? 'text' : 'password'}
                  onChange={this.handlePasswordChange}
                  label="Senha"
                />
                <span
                  role="button"
                  tabIndex="0"
                  className={this.state.viewPassaword ? 'icon-password active' : 'icon-password'}
                  onClick={this.togglePassword}
                />
              </div>

              <div className="btn-enviar">
                <Button
                  variant="contained"
                  disableElevation
                  onClick={this.handleSubmit}
                  disabled={isLoading}
                  type="submit"
                >
                  {isLoading ? (
                    <Loader type="Ball-Triangle" color="#00BFFF" height="20" width="20" />
                  ) : (
                      'Entrar'
                    )}
                </Button>
              </div>

              {/* <button
                type="button"
                className="forget-password"
                onClick={() => this.modalChangePassword.current.setState({ modalActive: true })}
              >
                <span>ESQUECI MINHA SENHA</span>
              </button> */}

              {version !== null && (
                <div style={{ display: 'flex', justifyContent: 'center', fontSize: 11 }}>
                  <p>
                    <span>{`Versão ${version}`}</span>
                  </p>
                </div>
              )}

              <AcceptTermsModal
                onClose={() => {
                  this.toggleModalBoxAcceptTerms();
                  this.forceLogout();
                }}
                show={this.state.modalBoxes.acceptTerm}
                history={this.props.history}
              />

              <AccessDeniedModal
                onClose={() => {
                  this.toggleModalBoxAccessDenied();
                  this.forceLogout();
                }}
                modalActive={this.state.modalBoxes.accessDenied}
              />

              <AccessDeniedTermNotAcceptedModal
                onClose={() => {
                  this.toggleModalBoxTermNotAccepted();
                  this.forceLogout();
                }}
                modalActive={this.state.modalBoxes.accessDeniedTerm}
              />

              <Dialog
                ref={this.modalChangePassword}
                header="Recuperação de senha"
                buttons={[
                  {
                    title: 'Fechar',
                    callback: () =>
                      this.modalChangePassword.current.setState({ modalActive: false })
                  },
                  {
                    title: 'Enviar',
                    callback: event => this.sendRecoverTokenEmail(event)
                  }
                ]}
              >
                <Fragment>
                  <div className="changePsw_box">
                    <p className="changePsw_paragraph">
                      Insira seu código do prestador no campo abaixo
                    </p>

                    <Input
                      label="Código do Prestador"
                      type="number"
                      pattern="[0-9]*"
                      inputmode="numeric"
                      onChange={this.handleChangeInputBenefCode}
                    />
                  </div>
                </Fragment>
              </Dialog>

              <Dialog
                ref={this.modalConfirmEmail}
                header="Recuperação de senha"
                buttons={[
                  {
                    title: 'Fechar',
                    callback: () => this.modalConfirmEmail.current.setState({ modalActive: false })
                  },
                  {
                    title: 'Enviar',
                    callback: () => this.validateRecoverToken()
                  }
                ]}
              >
                <Fragment>
                  <div className="changePsw_box">
                    <p>{`Insira o código de recuperação enviado para o e-mail: ${emailUser}.`}</p>
                    <Input
                      label="Código de recuperação"
                      type="text"
                      defaultValue=""
                      onChange={this.handleChangeInputResetToken}
                    />
                  </div>
                </Fragment>
              </Dialog>

              <Dialog
                ref={this.modalResultChangedPassword}
                header="Recuperação de senha"
                buttons={[
                  {
                    title: 'Fechar',
                    callback: () =>
                      this.modalResultChangedPassword.current.setState({ modalActive: false })
                  },
                  {
                    title: 'Enviar',
                    callback: () => this.createNewLogin()
                  }
                ]}
              >
                <Fragment>
                  <div className="changePsw_box">
                    <p>Preencha os dados abaixo para cadastrar a nova senha</p>
                    <Input
                      label="Nova senha"
                      type="password"
                      onChange={this.handleChangeInputNewPassword}
                    />
                    <Input
                      label="Confirmar senha"
                      type="password"
                      onChange={this.handleChangeInputConfirmPassword}
                    />
                    <Input
                      label="DDD"
                      type="number"
                      value={this.state.valueInputDdd}
                      onChange={this.handleChangeInputDdd}
                      onKeyDown={evt =>
                        evt.keyCode == 8 || evt.keyCode == 46
                          ? false
                          : (evt.key === 'e' ||
                            evt.key === '.' ||
                            evt.key === ',' ||
                            evt.key === '-' ||
                            Number.isNaN(evt.key)) &&
                          evt.preventDefault()
                      }
                    />
                    <Input
                      label="Celular"
                      type="number"
                      value={this.state.valueInputCelular}
                      onChange={this.handleChangeInputCelular}
                      onKeyDown={evt =>
                        evt.keyCode == 8 || evt.keyCode == 46
                          ? false
                          : (evt.key === 'e' ||
                            evt.key === '.' ||
                            evt.key === ',' ||
                            evt.key === '-' ||
                            Number.isNaN(evt.key)) &&
                          evt.preventDefault()
                      }
                    />
                  </div>
                </Fragment>
              </Dialog>

              <Dialog
                ref={this.modalResultChangeSuccess}
                header="Recuperação de senha"
                buttons={[
                  {
                    title: 'Fechar',
                    callback: () =>
                      this.modalResultChangeSuccess.current.setState({ modalActive: false })
                  }
                ]}
              >
                <Fragment>
                  <div>
                    <p>Dados atualizados com sucesso!</p>
                  </div>
                </Fragment>
              </Dialog>
            </div>
          </div>
        </form>
      </>
    );
  }
}

const mapStateToProps = ({ login }) => ({ login });

export default connect(mapStateToProps, { authenticate, logout })(LoginScreen);
